// @flow

import React from 'react'

type ArrowProps = {
  direction: 'up' | 'down' | 'left' | 'right'
}

export function Arrow(props: ArrowProps) {
  const {direction} = props
  switch (direction) {
    case 'up':
      return (
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g stroke="#3D8704" strokeWidth="2" fill="none">
            <path d="M1,13 C5.83333333,13 8.91666667,10.3333333 10.25,5" />
            <polyline points="6 6 11 4 13 9" />
          </g>
        </svg>
      )
    case 'down':
      return (
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g stroke="#E51C30" strokeWidth="2" fill="none">
            <polyline points="13 7 11 12 6 10" />
            <path d="M1,3 C5.83333333,3 8.91666667,5.66666667 10.25,11" />
          </g>
        </svg>
      )

    case 'right':
    default:
      return (
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g stroke="#686a6c" strokeWidth="2" fill="none">
            <path d="M1,8 L12.5,8" />
            <polyline points="9 4 13 8 9 12" />
          </g>
        </svg>
      )
  }
}

export function toDirection(
  endringAntall: number
): 'up' | 'down' | 'left' | 'right' {
  if (endringAntall > 0) {
    return 'up'
  } else if (endringAntall < 0) {
    return 'down'
  }
  return 'right'
}



// WEBPACK FOOTER //
// ./src/shared/components/shared/Arrow/index.js